export default __webpack_public_path__ + "static/media/whiteCircle.47b476d2.png";